// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"a5132163","188":"3907fe43","295":"e37f209d","325":"d6616d4c","474":"bf5652e0","552":"51767a10","637":"5db2f931","653":"b3c1abfb","661":"fb94ff38","737":"4452fee6","745":"c3c40034","821":"e58362e4","836":"814ed038","898":"17713fc6","901":"b1a404a7","906":"177cc50b"}[chunkId] + ".chunk.js";
};